"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _usePrevious = _interopRequireDefault(require("./usePrevious"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useCvvInput = function useCvvInput() {
  var cvvLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
  var errors = arguments.length > 1 ? arguments[1] : undefined;
  var setValue = arguments.length > 2 ? arguments[2] : undefined;
  var clearError = arguments.length > 3 ? arguments[3] : undefined;
  var updatedCvvLength = cvvLength;
  var previousCvvLength = (0, _usePrevious["default"])(updatedCvvLength);

  if (previousCvvLength !== updatedCvvLength) {
    setValue('cvv', '');

    if (errors.cvv) {
      clearError('cvv');
    }
  }
};

var _default = useCvvInput;
exports["default"] = _default;